import { initializeApp } from "firebase/app";
import {
  FacebookAuthProvider,
  getAuth,
  TwitterAuthProvider,
} from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, query } from "firebase/firestore";
import { getAnalytics, initializeAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_Api_Key,
  authDomain: process.env.REACT_APP_Auth_Domain,
  databaseURL: process.env.REACT_APP_Database_URL,
  projectId: "setu-deso",
  storageBucket: process.env.REACT_APP_Storage_Bucket,
  messagingSenderId: process.env.REACT_APP_Messaging_SenderId,
  appId: process.env.REACT_APP_App_Id,
  measurementId: process.env.REACT_APP_Measurement_Id,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
initializeAnalytics(app);
export const auth = getAuth(app);
export const firestore = getFirestore(app);

export const twitterAuthProvider = new TwitterAuthProvider();
export const facebookAuthProvider = new FacebookAuthProvider();

export const analytics = getAnalytics();

export const createTwitterUserProfileDocument = async (
  userAuth,
  deso_id,
  token_response
) => {
  if (!userAuth) return;

  const userRef = doc(firestore, `twitter_users/${userAuth?.uid}`);
  const userSnapShot = await getDoc(query(userRef));
  if (!userSnapShot?.exists()) {
    const userEntries = Object.entries(userAuth?.toJSON()).filter(
      (entry) => entry[1] !== undefined && entry[0] !== "stsTokenManager"
    );
    if (token_response) {
      userEntries.push(["token_response", token_response]);
    }
    try {
      await setDoc(
        userRef,
        {
          ...userSnapShot.data(),
          twitterCred: Object.fromEntries(userEntries),
          deso_id: deso_id,
        },

        { merge: true }
      );
      // window.location.href = "sync_your_content";
    } catch (error) {
      console.error(error);
    }
  } else {
    // window.location.href = "sync_your_content";
  }
};

export const createDesoUserProfileDocument = async (uid, payload) => {
  if (!uid) return;

  const userRef = doc(firestore, `deso_users/${uid}`);
  const userSnapShot = await getDoc(query(userRef));

  if (!userSnapShot?.exists()) {
    const userEntries = Object.entries(payload).filter(
      (entry) => entry[1] !== undefined
    );
    try {
      await setDoc(
        userRef,
        { ...userSnapShot.data(), desoCred: Object.fromEntries(userEntries) },
        { merge: true }
      );
    } catch (error) {
      console.error(error);
    }
  }
};
export const saveTweets = async (uid, id) => {
  if (!uid) return;
  const userRef = doc(firestore, `users/${uid}`);
  const userSnapShot = await getDoc(query(userRef));
  try {
    await setDoc(
      userRef,
      { ...userSnapShot.data(), tweets: id },
      { merge: true }
    );
  } catch (error) {
    console.error(error);
  }
};
export const addTwitterId = async (uid, twitter_id) => {
  const userRef = doc(firestore, `deso_users/${uid}`);
  const userSnapShot = await getDoc(query(userRef));
  if (userSnapShot.exists()) {
    try {
      await setDoc(userRef, { twitter_id: twitter_id }, { merge: true });
    } catch (error) {
      console.error(error);
    }
  }
};

// get token data from firestore
export const getTokenData = async (uid) => {
  const userRef = doc(firestore, `twitter_users/${uid}`);
  const userSnapShot = await getDoc(query(userRef));
  if (userSnapShot.exists()) {
    const oauthAccessToken =
      userSnapShot.data().twitterCred?.token_response?.oauthAccessToken;
    const oauthTokenSecret =
      userSnapShot.data().twitterCred?.token_response?.oauthTokenSecret;
    const twitterUserName =
      userSnapShot.data().twitterCred?.token_response?.screenName;
    return { oauthAccessToken, oauthTokenSecret, twitterUserName };
  }
};
